import { router } from '@/app/router/router'
import { useAuth } from '@/features/auth/hooks/useAuth'
import { useAuthSessionSync } from '@/features/auth/hooks/useAuthSessionSync'
import { queryClient } from '@/shared/query'
import { NotificationProvider } from '@/shared/notifications/notification-provider'
import { LanguageProvider } from '@/shared/i18n/LanguageProvider'
import { QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from '@tanstack/react-router'

export function TanStackRootProvider() {
  return (
    <QueryClientProvider client={queryClient}>
      <NotificationProvider>
        <LanguageProvider>
          <RouterProviderWithContext />
        </LanguageProvider>
      </NotificationProvider>
    </QueryClientProvider>
  )
}

function RouterProviderWithContext() {
  useAuthSessionSync()
  const auth = useAuth()

  return <RouterProvider router={router} context={{ auth }} />
}
